import { CallCenterDefault } from 'components/features'

const CallCenter = () => {
  return (
    <CallCenterDefault/>
  )
}

export default CallCenter
